import { defineComponent as _defineComponent } from 'vue';
import { library } from "@fortawesome/fontawesome-svg-core";
import { faCaretDown, faCopy, faEye, faPause, faTimesCircle } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { BLink } from "bootstrap-vue";
import { computed } from "vue";
import {} from "@/api";
export default /*#__PURE__*/ _defineComponent({
    __name: 'DatasetName',
    props: {
        item: null
    },
    emits: ["copyDataset", "showDataset"],
    setup(__props, { emit }) {
        const props = __props;
        library.add(faCaretDown, faCopy, faEye, faTimesCircle, faPause);
        const getName = computed(() => {
            return props.item.name || "Unavailable";
        });
        const isError = computed(() => {
            return props.item.state === "error";
        });
        const isPaused = computed(() => {
            return props.item.state === "paused";
        });
        function copyDataset() {
            emit("copyDataset", props.item);
        }
        return { __sfc: true, props, emit, getName, isError, isPaused, copyDataset, faCaretDown, faCopy, faPause, faTimesCircle, FontAwesomeIcon, BLink };
    }
});
